<template>
    <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">{{ $t("app.modules.customers.details_customer") }}</h4>
    <div class="row">
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.bussiness_name") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.razonSocial }}</small>
            </h5>
        </div>
       
       
       
    </div>
    <div class="row">
        <div :class="sizesfx">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.billing_information") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.descripcion }}</small>
            </h5>
        </div>

   </div>

   <div class="row">

        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.rfc") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.rfc }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.street") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.calle }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.numExt") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.numExterior }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.numInt") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.numInterior }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.suburb") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.colonia }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.municipality") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.delegacionMunicipio }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.cp") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.codigoPostal }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.state") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.estado }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.country") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.pais }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.language") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.idioma }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.phone1") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.telefono1 }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.phone2") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.telefono2 }}</small>
            </h5>
        </div>
        
   </div>

   <div class="row">
        <div :class="sizesfx">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.delivery_addresses") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.descripcion }}</small>
            </h5>
        </div>

   </div>

   <div class="col-md-12">

      <el-table stripe style="width: 100%" :data="item.direccionesEntrega">

        <el-table-column
              prop="razonSocial"
              :label="this.$t('app.modules.customers.business_name')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="calle"
              :label="this.$t('app.modules.customers.street')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="numExterior"
              :label="this.$t('app.modules.customers.numExt')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="numInterior"
              :label="this.$t('app.modules.customers.numInt')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="colonia"
              :label="this.$t('app.modules.customers.suburb')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="delegacionMunicipio"
              :label="this.$t('app.modules.customers.municipality')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="codigoPostal"
              :label="this.$t('app.modules.customers.cp')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="estado"
              :label="this.$t('app.modules.customers.state')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="pais"
              :label="this.$t('app.modules.customers.country')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="idioma"
              :label="this.$t('app.modules.customers.language')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="telefono1"
              :label="this.$t('app.modules.customers.phone1')"

              width="250"
            >
        </el-table-column>

        <el-table-column
              prop="telefono2"
              :label="this.$t('app.modules.customers.phone2')"

              width="250"
            >
        </el-table-column>



      </el-table>

   </div>


   <div class="row">
        <div :class="sizesfx">
            <h4>
            <small>
                <b>{{ $t("app.modules.customers.contact_information") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.descripcion }}</small>
            </h5>
        </div>

   </div>


   <div class="col-md-12">

     <el-table stripe style="width: 100%" :data="item.contactoClientes">

            <el-table-column
              prop="nombre"
              :label="this.$t('app.modules.customers.nameContact')"

              width="250"
            >
            </el-table-column>
            <el-table-column
              prop="telefono"
              :label="this.$t('app.modules.customers.phoneContact')"

              width="250"
            >
            </el-table-column>
            <el-table-column
              prop="email"
              :label="this.$t('app.modules.customers.email')"

              width="250"
            >
            </el-table-column>

     </el-table>

   </div>
    
  </modal>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
export default {
  components: {},
  data() {
    return {
    sizes: "col-md-4 col-sm-12",
    sizesfx: "col-md-8 col-sm-12",
      item: {
        idTipoMoneda: 0, 
        nombre: '', 
        abreviatura: '', 
        activo: true,
        idEmpresa: 0
      },
      payload: {
        idTipoMoneda: 0, 
        nombre: '', 
        abreviatura: '', 
        activo: true,
        idEmpresa: 0
      },
      switches: {
        withIconsOn: true
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      
      modalEdit: false,
      modals: {
        classic: false
      },
      contactoClientes:[],
    };
  },
  mounted() {
    EventBus.$on("clientes-detalles", async item => {
      //console.log(item);
      
      this.item = item;
        this.$swal.fire({
          title: "Por favor espera",
          html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
          showConfirmButton: false  
        });
      this.$swal.close();
      this.modals.classic = true;
      
    });
  },
  methods: {
    cancelEdit() {
      this.modalEdit = false;
      this.$refs.formEdit.reset();
    },
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 10px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
.modal-dialog {
    max-width: 1000px !important;
    margin: 1.75rem auto;
}
</style>
